import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiKey,
  CreatedApiKey,
  FavoritesList,
  MinimalProfile,
  Profile,
  UpdatePassword,
} from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private httpClient: HttpClient) {}

  public getProfile(): Observable<Profile> {
    return this.httpClient.get<Profile>(`${environment.api}/me/profile`);
  }

  public getFavorites(size: number, page: number): Observable<FavoritesList> {
    return this.httpClient.get<FavoritesList>(
      `${environment.api}/me/favorites?size=${size}&page=${page}`,
    );
  }

  public getApiKeys(): Observable<{ keys: Array<ApiKey> }> {
    return this.httpClient.get<{ keys: Array<ApiKey> }>(
      `${environment.api}/me/api-keys`,
    );
  }

  public createApiKey(name: string): Observable<CreatedApiKey> {
    return this.httpClient.post<CreatedApiKey>(
      `${environment.api}/me/api-keys`,
      {
        name,
      },
    );
  }

  public deleteApiKey(keyId: string): Observable<void> {
    return this.httpClient.delete<void>(
      `${environment.api}/me/api-keys/${keyId}`,
    );
  }

  public updatePassword(updatePassword: UpdatePassword): Observable<void> {
    return this.httpClient.put<void>(
      `${environment.api}/me/update-password`,
      updatePassword,
    );
  }

  public createUser(user: MinimalProfile): Observable<Profile> {
    return this.httpClient.post<Profile>(
      `${environment.api}/company/users/new`,
      user,
    );
  }

  public updateUser(id: number, user: MinimalProfile): Observable<void> {
    return this.httpClient.put<void>(
      `${environment.api}/company/users/${id}`,
      user,
    );
  }

  public deleteUser(id: number): Observable<void> {
    return this.httpClient.delete<void>(
      `${environment.api}/company/users/${id}`,
    );
  }

  public getUsers(): Observable<Profile[]> {
    return this.httpClient.get<Profile[]>(`${environment.api}/company/users`);
  }
}
